import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiMenu, FiX, FiGlobe } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import NotificationBell from './NotificationBell';
import '../styles/App.css';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleLanguage = () => {
    const newLang = i18n.language.startsWith('pt') ? 'en' : 'pt';
    i18n.changeLanguage(newLang);
  };

  const handleLogout = async () => {
    await logout();
    setIsMenuOpen(false);
    navigate('/');
  };

  const close = () => setIsMenuOpen(false);

  const langLabel = i18n.language.startsWith('pt') ? 'PT-BR' : 'EN-US';

  // Get first name only for cleaner display
  const displayName = currentUser?.displayName
    ? currentUser.displayName.split(' ')[0]
    : currentUser?.email?.split('@')[0];

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand" onClick={close}>
        <img src="/logo-transparent.png" alt="RifaMaker" style={{ height: '36px', marginRight: '0.3rem', verticalAlign: 'middle' }} />
      </Link>

      <button className="navbar-hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
        {isMenuOpen ? <FiX size={22} /> : <FiMenu size={22} />}
      </button>

      <div className={`navbar-links ${isMenuOpen ? 'open' : ''}`}>
        <Link to="/" onClick={close}>{t('nav.home')}</Link>
        <Link to="/raffles" onClick={close}>{t('nav.raffles')}</Link>

        {currentUser && (
          <>
            <Link to="/create" onClick={close}>{t('nav.create')}</Link>
            <Link to="/my-raffles" onClick={close}>{t('nav.myRaffles')}</Link>
          </>
        )}


        <button className="lang-toggle" onClick={toggleLanguage}>
          <FiGlobe size={14} /> {langLabel}
        </button>

        {currentUser ? (
          <>
            <NotificationBell />
            <span style={{
              fontWeight: 600,
              color: 'var(--primary)',
              fontSize: '0.9rem',
              padding: '0.4rem 0.8rem',
              background: 'rgba(108, 92, 231, 0.08)',
              borderRadius: 'var(--radius-xl)'
            }}>
              {displayName}
            </span>
            <button
              onClick={handleLogout}
              className="btn btn-sm"
              style={{
                color: 'var(--danger)',
                border: '1.5px solid var(--danger)',
                background: 'transparent',
                fontSize: '0.85rem',
                padding: '0.35rem 0.9rem'
              }}
            >
              {t('nav.logout')}
            </button>
          </>
        ) : (
          <>
            <Link to="/login" onClick={close} style={{ fontWeight: 600, color: 'var(--primary)' }}>
              {t('nav.login')}
            </Link>
            <Link
              to="/register"
              onClick={close}
              style={{
                background: 'linear-gradient(135deg, #6C5CE7, #00CEC9)',
                color: '#ffffff',
                fontWeight: 700,
                padding: '0.45rem 1.2rem',
                borderRadius: 'var(--radius-sm)',
                fontSize: '0.9rem',
                textDecoration: 'none',
                boxShadow: '0 3px 12px rgba(108, 92, 231, 0.35)',
                letterSpacing: '0.02em',
                whiteSpace: 'nowrap',
              }}
            >
              {t('nav.register')}
            </Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
